import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface SnackbarConfig {
  duration?: number;
  action?: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly DEFAULT_DURATION = 3000;

  constructor(private readonly snackBar: MatSnackBar) {}

  showSuccess(snackbarConfig: SnackbarConfig) {
    this.snackBar.open(snackbarConfig.message, snackbarConfig.action, {
      duration: snackbarConfig.duration ?? this.DEFAULT_DURATION,
      panelClass: ['success-snackbar'],
    });
  }

  showError(snackbarConfig: SnackbarConfig) {
    this.snackBar.open(snackbarConfig.message, snackbarConfig.action, {
      duration: snackbarConfig.duration ?? this.DEFAULT_DURATION,
      panelClass: ['error-snackbar'],
    });
  }

  showWarning(snackbarConfig: SnackbarConfig) {
    this.snackBar.open(snackbarConfig.message, snackbarConfig.action, {
      duration: snackbarConfig.duration ?? this.DEFAULT_DURATION,
      panelClass: ['warning-snackbar'],
    });
  }
}
